(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Inline predictive search
  (function() {
    const input = document.getElementById('Search-In-Header-Inline');
    const results = document.getElementById('header-inline-results');
    if (!input || !results) return;

    let debounceTimer;

    input.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      const q = input.value.trim();

      if (q.length < 2) {
        results.innerHTML = '';
        results.style.display = 'none';
        return;
      }

      debounceTimer = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=5&resources[options][fields]=title,product_type,variants.title')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            const res = data.resources && data.resources.results || {};
            const products = res.products || [];
            const collections = res.collections || [];

            if (!products.length && !collections.length) {
              results.innerHTML = '';
              results.style.display = 'none';
              return;
            }

            let html = '<div class="header__search-columns">';

            html += '<div class="header__search-col">';
            html += '<div class="header__search-group-label">Colecciones</div>';
            if (collections.length) {
              html += collections.map(function(c) {
                const img = c.image ? '<img src="' + c.image + '" alt="' + c.title + '" class="header__search-result-img">' : '<div class="header__search-result-img header__search-result-img--placeholder"></div>';
                return '<a href="' + c.url + '" class="header__search-result-item">' +
                  img +
                  '<div class="header__search-result-info">' +
                    '<span class="header__search-result-title">' + c.title + '</span>' +
                    '<span class="header__search-result-type">Colección</span>' +
                  '</div>' +
                '</a>';
              }).join('');
            } else {
              html += '<p class="header__search-empty">Sin resultados</p>';
            }
            html += '</div>';

            html += '<div class="header__search-col header__search-col--right">';
            html += '<div class="header__search-group-label">Productos</div>';
            if (products.length) {
              html += products.map(function(p) {
                const img = p.image ? '<img src="' + p.image + '" alt="' + p.title + '" class="header__search-result-img">' : '<div class="header__search-result-img header__search-result-img--placeholder"></div>';
                return '<a href="' + p.url + '" class="header__search-result-item">' +
                  img +
                  '<div class="header__search-result-info">' +
                    '<span class="header__search-result-title">' + p.title + '</span>' +
                    '<span class="header__search-result-type">' + (p.product_type || '') + '</span>' +
                  '</div>' +
                '</a>';
              }).join('');
            } else {
              html += '<p class="header__search-empty">Sin resultados</p>';
            }
            html += '</div>';

            html += '</div>';
            html += '<a href="/search?q=' + encodeURIComponent(q) + '&type=product" class="header__search-view-all">Ver todos los resultados para "<strong>' + q + '</strong>" →</a>';

            results.innerHTML = html;
            results.style.display = 'block';
          })
          .catch(function() {
            results.innerHTML = '';
            results.style.display = 'none';
          });
      }, 200);
    });

    document.addEventListener('click', function(e) {
      if (!input.contains(e.target) && !results.contains(e.target)) {
        results.style.display = 'none';
      }
    });

    input.addEventListener('focus', function() {
      if (results.innerHTML) results.style.display = 'block';
    });

    // Submit form — go to search results
    input.closest('form').addEventListener('submit', function(e) {
      e.preventDefault();
      const q = input.value.trim();
      if (q) window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
